export default __webpack_public_path__ + "static/media/enter-birth-details.b06fc350.png";